// in usePdf.ts
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useFormStore } from '@/features/blueprint/stores/useFormStore';
import { getQuestionSchema } from '@/features/blueprint/schema/questionSchema';
import PdfApiService from '@/services/PdfApiService';
import type { PdfResponseDto } from '@@@/dto/api/PdfResponseDto';
import type { PdfRequestDto } from '@@@/dto/api/PdfRequestDto';
import { evaluateRecommendationRules } from '@/features/planSelection/composables/useRecommendation';

export function usePdf() {
    const { t } = useI18n();
    const formStore = useFormStore();
    const loading = ref(false);
    const error = ref<Error | null>(null);
    const result = ref<PdfResponseDto | null>(null);

    const generatePdf = async () => {
        loading.value = true;
        error.value = null;
        try {
            // 👉 Spread into a new plain object
            const plainAnswers = { ...formStore.answers };
            const recommendedPackages = evaluateRecommendationRules(plainAnswers)
            const payload: PdfRequestDto = {
                questions: getQuestionSchema(t),
                answers: plainAnswers,
                recommendations: recommendedPackages
            };

            console.debug('PDF payload', JSON.stringify(payload, null, 2));
            result.value = await PdfApiService.get(payload);
        } catch (err: unknown) {
            error.value = err as Error;
        } finally {
            loading.value = false;
        }
    };

    return { generatePdf, loading, error, result };
}
